import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";

// API call
import { userLoginRequest } from "../../../api/api";

// Custom UI Components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";

import Card from "@mui/material/Card";
import Logo from "assets/images/logo.png";
function SignIn() {
  const navigate = useNavigate();

  return (
    <BasicLayout>
      <Card
        sx={{
          width: { xs: "90%", sm: 420 },
          borderRadius: "24px",
          backdropFilter: "blur(20px)",
          background: "#fff",
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          overflow: "hidden",
        }}
      >
        <MDBox
          sx={{
            textAlign: "center",
            mt: -5,
            mb: -10,
            background: "#fff",
            color: "#fff",
          }}
        >
          <img src={Logo} width={300} height={300} />
        </MDBox>
        <MDBox pt={4} pb={4} px={4}>
          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email("Must be a valid email").required("Email is required"),
              password: Yup.string().required("Password is required"),
            })}
            onSubmit={async (values, { setErrors, setSubmitting }) => {
              try {
                setSubmitting(true);

                const response = await userLoginRequest({
                  email: values.email,
                  password: values.password,
                });

                // Try all possible token response formats
                const token =
                  response?.data?.data?.token ||
                  response?.data?.data?.access_token ||
                  response?.data?.token;

                if (token) {
                  // localStorage.setItem("authToken", token);
                  const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 hours
                  localStorage.setItem("authToken", token);
                  localStorage.setItem("authTokenExpiry", expiryTime.toString());

                  localStorage.setItem("user", JSON.stringify(response.data.data));
                  navigate("/dashboard");
                } else {
                  throw new Error("Invalid login response: token not found");
                }
              } catch (error) {
                setErrors({
                  submit: error?.response?.data?.message || error?.message || "Login failed",
                });
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form noValidate onSubmit={handleSubmit}>
                <MDBox mb={2}>
                  <MDInput
                    fullWidth
                    label="Email Address"
                    name="email"
                    type="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                      },
                    }}
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    fullWidth
                    label="Password"
                    name="password"
                    type="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.password && errors.password)}
                    helperText={touched.password && errors.password}
                  />
                </MDBox>
                {errors.submit && (
                  <MDTypography color="error" variant="caption">
                    {errors.submit}
                  </MDTypography>
                )}
                <MDBox mt={4} mb={1}>
                  <MDButton
                    type="submit"
                    fullWidth
                    disabled={isSubmitting}
                    sx={{
                      height: 50,
                      borderRadius: "12px",
                      fontSize: "15px",
                      fontWeight: 600,
                      textTransform: "none",
                      background: "linear-gradient(135deg,#1976d2,#42a5f5)",
                      color: "#fff",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 10px 20px rgba(25,118,210,.3)",
                      },
                      transition: "all .3s ease",
                    }}
                  >
                    {isSubmitting ? "Signing in..." : "Sign In"}
                  </MDButton>
                </MDBox>
              </form>
            )}
          </Formik>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default SignIn;
